import facebook from './facebook';
import bing from './bing';

export default {
  facebook,
  bing
};
